import { useState } from 'react';

// Product image — renders real photography when `src` is provided and loads,
// otherwise gracefully falls back to a dark placeholder rectangle with a
// faint gold border. Real photos are read from PRODUCTS auto-resolution
// (/products/<code>.jpg in the public dir).

export const ProductImage = ({
  code,
  label,
  src,
  alt,
  ratio = 'aspect-[4/5]',
  objectFit = 'cover',
  className = '',
}) => {
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src) && !failed;

  if (showImage) {
    return (
      <div
        className={`relative ${ratio} bg-mb hairline border-gold overflow-hidden ${className}`}
        data-testid={`product-image-${code || 'x'}`}
      >
        <img
          src={src}
          alt={alt || label || code || 'MR. BOSS & CO.'}
          onError={() => setFailed(true)}
          className="absolute inset-0 w-full h-full"
          style={{ objectFit }}
          loading="lazy"
        />
        {code && (
          <div
            className="absolute left-3 bottom-3 font-display text-[9px] tracking-[0.32em] uppercase text-gold bg-mb/85 px-2 py-1 hairline border-subtle"
          >
            {code}
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className={`product-placeholder ${ratio} ${className}`}
      data-testid={`product-image-${code || 'x'}`}
    >
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-6">
        <div className="font-display text-[11px] tracking-[0.34em] uppercase text-gold opacity-70">
          {code || 'MR. BOSS & CO.'}
        </div>
        {label && (
          <div className="mt-3 font-display italic text-[13px] text-mb-muted">
            {label}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductImage;
